import React from "react";

import { Box, CardContent, Typography, useTheme } from "@mui/material";

import ActionsList from "./ActionsList";
import { Chapter } from "../../../services/episode.service";
import { toHHMMSS } from "../../../../../utils/formatTIme";
import InsightsModalManager, {
  ModalType,
} from "../../../../common/ModalManager";
import { Category } from "../../../../common/types";
import InsightCardShell from "./InsightCardShell";

interface ChapterProps {
  chapters: Chapter[];
  chapterObject: Chapter;
  category: Category;
  refetch?: () => void;
}

export default function ChapterView({
  chapters,
  chapterObject,
  category,
  refetch,
}: ChapterProps) {
  const chapterTime = `${toHHMMSS(chapterObject.start)} - ${toHHMMSS(chapterObject.end)}`;
  const [openInsightsModalManager, setOpenInsightsModalManager] =
    React.useState(false);
  const theme = useTheme();

  const handleOpenInsightsModalManager = () =>
    setOpenInsightsModalManager(true);

  const handleCopy = () => {
    navigator.clipboard.writeText(chapterObject.title);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <InsightsModalManager
        open={openInsightsModalManager}
        setOpen={setOpenInsightsModalManager}
        modalType={ModalType.CHAPTERS}
        modalTitle="Edit Chapter"
        objectValue={{ title: chapterObject.title }}
        values={chapters}
        refetch={refetch || (() => {})}
        category={category}
      />

      <InsightCardShell
        sx={{
          p: 2,
          mb: 1.5,
        }}
      >
        <CardContent sx={{ p: 0 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            {/* Chapter Content */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
              {/* Chapter Title */}
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 500,
                  lineHeight: 1.5,
                  color: theme.palette.text.primary,
                  fontSize: "0.9rem",
                  mb: 0.5,
                  wordBreak: "break-word",
                }}
              >
                {chapterObject.title}
              </Typography>

              {/* Chapter Time */}
              <Typography
                variant="caption"
                sx={{
                  color: theme.palette.text.secondary,
                  fontSize: "0.75rem",
                  fontWeight: 400,
                }}
              >
                {chapterTime}
              </Typography>
            </Box>

            {/* Action Buttons */}
            <ActionsList
              handleOpenInsightsModalManager={handleOpenInsightsModalManager}
              handleCopy={handleCopy}
            />
          </Box>
        </CardContent>
      </InsightCardShell>
    </Box>
  );
}
